ixModuleRouting("impactx.awarddecision", {
    "/awardDecisionsOwn": {
        template: "<ixa-award-decision-list-own></ixa-award-decision-list-own>",
        process: "AwardDecisionsOwn",
        workspace: "shop"
    },
    "/awardDecisionsSupplier": {
        template: "<ixa-award-decision-list-supplier></ixa-award-decision-list-supplier>",
        process: "AwardDecisionsSupplier",
        workspace: "shop"
    },
    "/awardDecisions": {
        template: "<ixa-award-decision-list-purchaser></ixa-award-decision-list-purchaser>",
        process: "AwardDecisionsPurchaser",
        workspace: "shop"
    },
    "/awardDecisionDetails/:id": {
        template: "<ixa-award-decision-detail-dialog></ixa-award-decision-detail-dialog>",
        process: "AwardDecisionsDetail",
        workspace: "shop"
    },
    "/parkedPurchaseRequestOwn": {
        template: "<ixa-parked-purchase-request-list-own></ixa-parked-purchase-request-list-own>",
        process: "StandstillInfoOwn",
        workspace: "shop",
    },
    "/parkedPurchaseRequestPurchaser": {
        template: "<ixa-parked-purchase-request-list-purchaser></ixa-parked-purchase-request-list-purchaser>",
        process: "StandstillInfoPurchaser",
        workspace: "shop",
    },
    '/releaseprsssi/:osutan': {
        template: "<ixa-purchase-request-release-osutan></ixa-purchase-request-release-osutan>",
        noSecurity: true,
        workspace: 'shop',
    },
});